module.exports = __webpack_public_path__ + "static/media/Plant Shop Icon.e2df8c86.png";